module.exports = __webpack_public_path__ + "img/5-ilpakamanioMASY.ef3d3735.jpg";